(function (window, document) {

    /**
     * Inicializuje live broadcast slider pre rozcestník kanálov.
     * Nastavuje Swiper, periodicky sťahuje stav kanálov zo servera
     * a dynamicky pridáva/odoberá voliteľné kanály (4, 6) podľa toho,
     * či práve vysielajú online.
     *
     * @param {Object} options - Konfigurácia slidera:
     *   rootSelector        - CSS selektor wrapper elementu slidera
     *   currentChannel      - ID aktuálne zobrazeného kanálu
     *   channelOrder        - Poradie kanálov v slideri
     *   optionalChannels    - Kanály, ktoré sa zobrazujú len keď vysielajú online
     *   fallbackChannelNameUrls - Záložné URL názvy kanálov (ak DB nemá name_url)
     *   batchEndpoint       - URL JSON endpointu pre stav všetkých kanálov naraz
     *   batchHandlerKey     - Kľúč pre intervalHandler (aby sa timeouty neprekrývali)
     */
    window.initLiveBroadcastSlider = function (options) {
        const settings = options || {};
        const root = document.querySelector(settings.rootSelector || '.broadcast-slider');
        const batchEndpoint = settings.batchEndpoint;

        if (
            !root ||
            root.getAttribute('data-live-slider-init') === '1' ||
            typeof window.Swiper !== 'function' ||
            typeof window.jQuery === 'undefined' ||
            !batchEndpoint
        ) {
            return;
        }

        const wrapper = root.querySelector('.swiper-wrapper');
        if (!wrapper) {
            return;
        }
        root.setAttribute('data-live-slider-init', '1');

        if (typeof window.intervalHandlers === 'undefined') {
            window.intervalHandlers = [];
        }

        const intervalHandlers = window.intervalHandlers;
        const $ = window.jQuery;
        const currentChannel = String(settings.currentChannel || '');
        const channelOrder = settings.channelOrder || ['1', '2', '3', '15', '4', '6'];
        const optionalChannels = settings.optionalChannels || ['3', '4', '6'];
        const fallbackChannelNameUrls = settings.fallbackChannelNameUrls || {};
        const batchHandlerKey = settings.batchHandlerKey || 'snippet-broadcast-live-all';
        const initialSlide = Number(root.getAttribute('data-initial-slide') || 0);
        const initialDesktopSlides = wrapper.querySelectorAll('.swiper-slide').length > 4 ? 4.3 : 4;

        const swiper = new window.Swiper(root, {
            initialSlide: initialSlide,
            spaceBetween: 0,
            slidesPerView: 1.5,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.3
                },
                992: {
                    slidesPerView: initialDesktopSlides,
                    pagination: {
                        enabled: false
                    }
                }
            }
        });

        const getSnippetId = function (channel) {
            return 'snippet-broadcast-' + channel + '-live';
        };

        const isOptionalChannel = function (channel) {
            return optionalChannels.indexOf(channel) >= 0;
        };

        const getSlide = function (channel) {
            return wrapper.querySelector('.swiper-slide[data-channel="' + channel + '"]');
        };

        const parseChannelNumber = function (value) {
            if (value === '' || value === null || value === undefined) {
                return Number.NaN;
            }
            return Number(value);
        };

        const isChannelActive = function (channelState) {
            return !!channelState && channelState.internet === 'Y';
        };

        const getChannelNameUrl = function (channel, channelState) {
            if (channelState && channelState.channel_name_url) {
                return channelState.channel_name_url;
            }

            return fallbackChannelNameUrls[channel] || '';
        };

        /**
         * Nahradí obsah snippet kontajnera novým HTML.
         * Namiesto priameho innerHTML swap sa používa replaceChild/appendChild,
         * aby sa predišlo zbytočnému reflow celého kontajnera.
         */
        const replaceSnippetContent = function (snippetContainer, snippetHtml) {
            if (!snippetHtml) {
                snippetContainer.innerHTML = '';
                return;
            }

            const placeholder = document.createElement('div');
            placeholder.innerHTML = snippetHtml;

            const snippetNew = placeholder.firstElementChild;
            if (!snippetNew) {
                return;
            }

            const snippetOld = snippetContainer.firstElementChild;
            if (snippetOld) {
                snippetContainer.replaceChild(snippetNew, snippetOld);
            } else {
                snippetContainer.appendChild(snippetNew);
            }
        };

        /**
         * Vytvorí prázdny DOM element slidu pre voliteľný kanál (4, 6).
         * Volá sa keď kanál začne vysielať online a jeho slide ešte v DOM neexistuje.
         */
        const buildOptionalSlide = function (channel) {
            const snippetId = getSnippetId(channel);
            const slide = document.createElement('div');
            slide.setAttribute('data-channel', channel);
            slide.className = 'swiper-slide tv tv__broadcast';
            slide.innerHTML = [
                '<div class="content">',
                '<a href="#" data-datalayer-item=""></a>',
                '<span class="col__title d-block"></span>',
                '<div id="' + snippetId + '"></div>',
                '</div>'
            ].join('');
            return slide;
        };

        /**
         * Aktualizuje CSS triedy, href a text slidu podľa aktuálneho stavu kanálu.
         * Nastavuje triedy tv--<name_url>, active (ak je to aktuálny kanál)
         * a offline (ak kanál práve nevysiela online).
         */
        const applySlideState = function (slide, channel, channelNameUrl, isActive) {
            const removableClasses = Array.from(slide.classList).filter(function (className) {
                return className.indexOf('tv--') === 0 || className === 'active' || className === 'offline';
            });

            removableClasses.forEach(function (className) {
                slide.classList.remove(className);
            });

            slide.classList.add('swiper-slide', 'tv', 'tv__broadcast', 'tv--' + channelNameUrl);
            if (currentChannel === channel) {
                slide.classList.add('active');
            }
            if (!isActive) {
                slide.classList.add('offline');
            }

            const anchor = slide.querySelector('a');
            if (anchor) {
                anchor.setAttribute('href', '/live/' + channelNameUrl);
                anchor.setAttribute('data-datalayer-item', channelNameUrl);
            }

            const title = slide.querySelector('.col__title');
            if (title) {
                title.className = 'col__title tv--' + channelNameUrl + ' d-block';
                title.textContent = isActive ? '' : 'Nevysielame online';
            }
        };

        /**
         * Vloží nový slide na správnu pozíciu v slideri podľa channelOrder.
         * Prechádza existujúce slidy a vloží nový pred prvý slide
         * s vyšším indexom v channelOrder. Ak taký neexistuje, pripojí na koniec.
         */
        const insertSlideInOrder = function (channel, slide) {
            const newIndex = channelOrder.indexOf(channel);
            const slides = wrapper.querySelectorAll('.swiper-slide[data-channel]');
            let inserted = false;

            slides.forEach(function (existingSlide) {
                if (inserted) {
                    return;
                }

                const existingIndex = channelOrder.indexOf(existingSlide.dataset.channel);
                if (existingIndex > newIndex) {
                    wrapper.insertBefore(slide, existingSlide);
                    inserted = true;
                }
            });

            if (!inserted) {
                wrapper.appendChild(slide);
            }
        };

        /**
         * Prepočíta slidesPerView pre desktop breakpoint (≥992px) a zavolá swiper.update().
         * Volá sa po každej zmene počtu slidov (pridanie/odobranie voliteľného kanálu).
         * Ak je slidov viac ako 4, použije 4.3 aby naznačil, že je čo scrollovať.
         */
        const refreshSwiperLayout = function () {
            const slideCount = wrapper.querySelectorAll('.swiper-slide').length;
            if (swiper.params && swiper.params.breakpoints && swiper.params.breakpoints[992]) {
                swiper.params.breakpoints[992].slidesPerView = slideCount > 4 ? 4.3 : 4;
            }
            swiper.update();
        };

        /**
         * Synchronizuje stav jedného kanálu v slideri s dátami zo servera.
         * - Ak je voliteľný kanál offline → odoberie jeho slide z DOM.
         * - Ak je voliteľný kanál online a slide neexistuje → vytvorí ho a vloží na správne miesto.
         * - Aktualizuje triedy, href a snippet obsah (program, progress bar) slidu.
         * Vracia true ak sa zmenil počet slidov (potrebný refreshSwiperLayout).
         */
        const syncChannel = function (channel, channelState, snippets) {
            const optionalChannel = isOptionalChannel(channel);
            const activeChannel = isChannelActive(channelState);
            const snippetId = getSnippetId(channel);
            const snippetHtml = snippets[snippetId];
            const channelNameUrl = getChannelNameUrl(channel, channelState);
            let slide = getSlide(channel);
            let layoutChanged = false;

            if (optionalChannel && !activeChannel) {
                if (slide) {
                    slide.remove();
                    layoutChanged = true;
                }
                return layoutChanged;
            }

            if (!slide) {
                if (!optionalChannel || !snippetHtml || !channelNameUrl) {
                    return layoutChanged;
                }

                slide = buildOptionalSlide(channel);
                insertSlideInOrder(channel, slide);
                layoutChanged = true;
            }

            applySlideState(slide, channel, channelNameUrl, activeChannel);

            const snippetContainer = slide.querySelector('#' + snippetId);
            if (snippetContainer) {
                replaceSnippetContent(snippetContainer, snippetHtml);
            }

            return layoutChanged;
        };

        /**
         * Spracuje odpoveď z batch endpointu a synchronizuje všetky kanály naraz.
         * Po synchronizácii zavolá refreshSwiperLayout ak sa zmenil počet slidov.
         */
        const syncAllChannels = function (data) {
            const channels = (data && data.channels) || {};
            const snippets = (data && data.snippets) || {};
            let layoutChanged = false;

            channelOrder.forEach(function (channel) {
                layoutChanged = syncChannel(channel, channels[channel] || {}, snippets) || layoutChanged;
            });

            if (layoutChanged) {
                refreshSwiperLayout();
            }
        };

        /**
         * Vypočíta optimálny interval ďalšieho pollovania pre jeden kanál
         * na základe toho, koľko sekúnd zostáva do konca aktuálneho programu.
         * Čím menej zostáva, tým kratší interval (až 10s) – kvôli presnosti prepnutia.
         *   elapsed < -90s  → 90s  (program ešte nezačal, nie je urgentné)
         *   elapsed < 0s    →  5s  (program začína o chvíľu)
         *   remaining > 5min → 60s
         *   remaining ≥ 90s  → 30s
         *   remaining < 90s  → 10s
         */
        const resolveChannelInterval = function (channelState) {
            const elapsed = parseChannelNumber(channelState && channelState.elapsed);
            const duration = parseChannelNumber(channelState && channelState.duration);

            if (Number.isNaN(duration) && Number.isNaN(elapsed)) {
                return 90000;
            }
            if (elapsed < -90) {
                return 90000;
            }
            if (elapsed < 0) {
                return 5000;
            }

            const remaining = duration - elapsed;
            switch (true) {
                case (remaining > 300):
                    return 60000;
                case (remaining >= 90):
                    return 30000;
                case (remaining < 90):
                    return 10000;
                default:
                    return 5000;
            }
        };

        /**
         * Určí celkový interval ďalšieho pollovania ako minimum
         * z intervalov všetkých kanálov – slider sa aktualizuje podľa
         * kanálu, ktorý to potrebuje najskôr.
         */
        const resolveNextPollInterval = function (channels) {
            let interval = null;

            channelOrder.forEach(function (channel) {
                const channelInterval = resolveChannelInterval(channels[channel] || {});
                interval = interval === null ? channelInterval : Math.min(interval, channelInterval);
            });

            return interval || 5000;
        };

        const scheduleNextPoll = function (interval) {
            clearTimeout(intervalHandlers[batchHandlerKey]);
            intervalHandlers[batchHandlerKey] = setTimeout(fetchAndSync, interval);
        };

        /**
         * Stiahne stav všetkých kanálov z batch endpointu (jeden request pre všetky),
         * aktualizuje slider a naplánuje ďalší polling podľa zostatkového času programov.
         * Pri chybe siete zopakuje pokus za 5 sekúnd.
         */
        const fetchAndSync = function () {
            $.get(batchEndpoint)
                .done(function (data) {
                    let payload = data;

                    if (typeof payload === 'string') {
                        try {
                            payload = JSON.parse(payload);
                        } catch (e) {
                            scheduleNextPoll(5000);
                            return;
                        }
                    }

                    syncAllChannels(payload || {});
                    scheduleNextPoll(resolveNextPollInterval((payload && payload.channels) || {}));
                })
                .fail(function () {
                    scheduleNextPoll(5000);
                });
        };

        fetchAndSync();
    };
})(window, document);
